import React from 'react';

export const SidebarMenuIcon = ({
  width = '20',
  height = '14',
  color = '#101828',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M1 7H19M1 1H19M1 13H19"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
